// import { useTranslation } from 'react-i18next';
import { Avatar } from '@/components';
import { useNavigate } from 'react-router-dom';
import { CustomerWithStatsDtoRead } from '@/store/services/MidleNestApi.service';

export default function Project({ stats, profile, ...props }: CustomerWithStatsDtoRead) {
  // const { t } = useTranslation();
  const navigation = useNavigate();
  return (
    <tr
      className='hover:bg-blue-50 dark:hover:bg-black/10 cursor-pointer'
      onClick={() => navigation(`/projects/${props?.id}`)}
    >
      <td className='text-left'>
        <div className='flex items-center my-2 lg:my-2.5'>
          {/*{logo?.path && <img src={logo?.path} className='w-8 h-8 mr-2 rounded-full' />}*/}
          <Avatar
            name={String(profile?.user?.name)}
            src={profile?.avatar?.src}
            className='w-8 h-8'
          />
          <span className='ml-2'>{profile?.user?.name}</span>
        </div>
        {/*<i className='icon-bell text-lg' />*/}
      </td>
      <td className='text-center'>
        {/*<p className='font-normal text-gray-500 lg:hidden'>{t('Active Quests')}</p>*/}
        <p className=' underline lg:no-underline'>{stats?.activeTasks}</p>
      </td>

      {/*<td className='flex items-center flex-wrap mt-4 lg:mt-0 -mb-2.5 lg:mb-0 w-full'>*/}
      <td className='text-center'>
        {/*<p className='font-normal text-gray-500 lg:hidden'>{t('Total Quests')}</p>*/}
        <p className=''>{stats?.totalTasks}</p>
      </td>

      <td className='text-center'>
        {/*<p className='font-normal text-gray-500 lg:hidden'>{t('Total Points')}</p>*/}
        <p className=''>{stats?.totalPoints}</p>
      </td>

      <td className='text-center'>
        {/*<p className='font-normal text-gray-500 lg:hidden'>{t('Active Points')}</p>*/}
        <p className=''>{stats?.activePoints}</p>
      </td>
      {/*</td>*/}
    </tr>
  );
}
